import React, { useEffect, useState, useCallback, useContext } from "react";
import "./benefitCardv2.css";
import { BenefitGrid } from "../../../types/enrollmentV2.types";
import TotalPremium from "./totalPremiumV2/TotalPremiumV2";
import { AuthContext } from "../../../contexts";
import { GetBenefitsQuery } from "../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../utils/api";
import renderCard from "./renderCardV2/RenderCardV2";
import { calculateTotalPremium } from "./helperFuntionsV2/CalculateTotalPremium";
import { processDependents } from "./helperFuntionsV2/ProcessDependent";
import { processRiders } from "./helperFuntionsV2/ProcessRider";
import { GROUP_NUMBER } from "../../../constants/groupNumber/groupNumber";

const BenefitCard = () => {
	const { member } = useContext(AuthContext);

	const [totalCorePremium, setTotalCorePremium] = useState<number>(0);
	const [totalVEBPremium, setTotalVEBPremium] = useState<number>(0);
	const [coreBenefits, setCoreBenefits] = useState<BenefitGrid[]>([]);
	const [coreTrueCount, setCoreTrueCount] = useState<any>({});
	const [vebTrueCount, setVebTrueCount] = useState<any>({});
	const [coreDependents, setCoreDependents] = useState<any>({});
	const [vebDependents, setvebDependents] = useState<any>({});
	const [vebRiderCount, setVebRideCount] = useState<any>({});
	const [vebRiders, setVebRiders] = useState<any>({});
	const [vebBenefits, setVebBenefits] = useState<BenefitGrid[]>([]);
	// console.log("==========>veb==>", vebBenefits);
	// vebBenefits.map((vebBenefit: BenefitGrid, index: number) => {
	// 	// // console.log("Items=================>", item);
	// 	vebBenefit.enrollments.map((planObj: BenefitGrid, index: number) => {
	// 		if (planObj.plan_name === planObj.base_plan_name) {
	// 			vebBenefit.plan_name = planObj.plan_name;
	// 			vebBenefit.plan_code = planObj.plan_code;
	// 		}
	// 	});
	// });
	// // console.log(
	// 	"testing done --",
	// 	coreTrueCount,
	// 	vebTrueCount,
	// 	coreDependents,
	// 	vebDependents,
	// 	vebRiderCount,
	// 	vebRiders
	// );
	const getBenefits = useCallback(async () => {
		// console.log("member", member);
		if (member) {
			const getBenefitsQuery: GetBenefitsQuery = {
				group_number: member.group_number,
				insured_SSN: member.SSN,
				member_SSN: member.SSN
			};
			const benefitsResponse: any = await trackPromise(api.enrollment.getBenefitsV2(getBenefitsQuery));
			// console.log("BenefitsNEWDATA__V2---->", benefitsResponse);
			if (benefitsResponse) {
				setCoreBenefits(benefitsResponse.core || []);
				setVebBenefits(benefitsResponse.veb || []);
				const totalCorePremium = calculateTotalPremium(benefitsResponse.core || []);
				const totalVEBPremium = calculateTotalPremium(benefitsResponse.veb || []);
				setTotalCorePremium(totalCorePremium);
				setTotalVEBPremium(totalVEBPremium);

				const { trueCountTemp: coreTrueCountTemp, dependentsTemp: coreDependentsTemp } = processDependents(
					benefitsResponse.core || []
				);
				const { trueCountTemp: vebTrueCountTemp, dependentsTemp: vebDependentsTemp } = processDependents(
					benefitsResponse.veb || []
				);
				const vebRidersAndCount = processRiders(benefitsResponse.veb || []);

				// console.log("testing done ok", vebRidersAndCount.riderTemp);
				setCoreTrueCount(coreTrueCountTemp);
				setVebTrueCount(vebTrueCountTemp);
				setCoreDependents(coreDependentsTemp);
				setvebDependents(vebDependentsTemp);
				setVebRideCount(vebRidersAndCount.trueRiderTemp);
				setVebRiders(vebRidersAndCount.riderTemp);
			}
		}
	}, [member]);
	// // console.log("testing done ---- 2", vebRiders, vebRiderCount);
	useEffect(() => {
		getBenefits();
	}, [getBenefits]);

	// console.log("CHEKING___HORHA___VEB__KA----------->", coreDependents);
	return (
		<>
			<div className="benefits-main-container">
				<TotalPremium coreTotalPremium={totalCorePremium} vebTotalPremium={totalVEBPremium} />
				<div className="plan-title-ammount">
					<div>
						<h1 className="plan-title">Core Plans</h1>
					</div>
					<div className="">
						<h1 className="core-total-gradient-text">
							${totalCorePremium ? totalCorePremium.toFixed(2) : ""}
						</h1>
					</div>
				</div>
				{coreBenefits.map((data: BenefitGrid, index) =>
					renderCard(
						data,
						index,
						false,
						coreBenefits,
						vebBenefits,
						coreTrueCount,
						vebTrueCount,
						coreDependents,
						vebDependents
					)
				)}

				{/* VEB */}
				{member.group_number === GROUP_NUMBER.Brookshire_Brothers ? (
					<>
						<div className="plan-title-ammount">
							<div>
								<h1
									className="plan-title-veb"
									style={{
										background: "linear-gradient(to right, #8a2be2, #d8bfd8)",
										WebkitBackgroundClip: "text",
										color: "transparent"
									}}
								>
									VEB Plans
								</h1>
							</div>
							<div className="">
								<h1 className="veb-total-gradient-text">
									${totalVEBPremium ? totalVEBPremium.toFixed(2) : ""}
								</h1>
							</div>
						</div>
						{vebBenefits.map((data: BenefitGrid, index) =>
							renderCard(
								data,
								index,
								true,
								coreBenefits,
								vebBenefits,
								coreTrueCount,
								vebTrueCount,
								coreDependents,
								vebDependents,
								vebRiderCount,
								vebRiders
							)
						)}
					</>
				) : null}
			</div>
		</>
	);
};

export default BenefitCard;
